import { useTranslation } from "react-i18next";
import TransferTemplate from "./templates/transfer-template";
import StayTemplate from "./templates/stay-template";
import HotelTemplate from "./templates/hotel-template";
import AgencyTemplate from "./templates/agency-template";
import HostelTemplate from "./templates/hostel-template";
import TourTemplate from "./templates/tour-template";
import RentalTemplate from "./templates/rental-template";

export const SERVICE_TEMPLATES = {
    transfer: TransferTemplate,
    stay: StayTemplate,
    tour: TourTemplate,
    rental: RentalTemplate,
    bike_rental: RentalTemplate,
    car_rental: RentalTemplate,
    boat_rental: RentalTemplate,
    helicopter_rental: RentalTemplate,
    plane_rental: RentalTemplate,
    van_rental: RentalTemplate,
} as const;

export const BUSINESS_TEMPLATES = {
    hotel: HotelTemplate,
    agency: AgencyTemplate,
    hostel: HostelTemplate,
} as const;

export const ALL_TEMPLATES = {
    ...SERVICE_TEMPLATES,
    ...BUSINESS_TEMPLATES,
} as const;


export const SELECT_BUSINESS_CATEGORIES = () => {
    const { t } = useTranslation();

    return [
        {
            label: t('pax_holder'),
            value: 'pax_holder',
        },
        {
            label: t('guide'),
            value: 'guide',
        },
        {
            label: t('coordinator'),
            value: 'coordinator',
        },
        {
            label: t('driver'),
            value: 'driver',
        },
        {
            label: t('hotel'),
            value: 'hotel',
        },
        {
            label: t('cabins'),
            value: 'cabins',
        },
        {
            label: t('ferry_company'),
            value: 'ferry_company',
        },
        {
            label: t('car_rental'),
            value: 'car_rental',
        },
        {
            label: t('sailing'),
            value: 'sailing',
        },
        {
            label: t('adventure'),
            value: 'adventure',
        },
        {
            label: t('bike_rental'),
            value: 'bike_rental',
        },
        {
            label: t('kayak'),
            value: 'kayak',
        },
        {
            label: t('rafting'),
            value: 'rafting',
        },
        {
            label: t('diving'),
            value: 'diving',
        },
        {
            label: t('carrier'),
            value: 'carrier',
        },
        {
            label: t('rental_house'),
            value: 'rental_house',
        },
        {
            label: t('hostel'),
            value: 'hostel',
        },
        {
            label: t('agency'),
            value: 'agency',
        },
        {
            label: t('lodging'),
            value: 'lodging',
        },
        {
            label: t('it_provider'),
            value: 'it_provider',
        },
        {
            label: t('gas_station'),
            value: 'gas_station',
        },
        {
            label: t('other'),
            value: 'other',
        },
    ]
}